import { FeedbackCategory } from './InlineFeedbackDialog';
import { feedbackDialogDropDownPlaceHolder } from './InlineFeedbackDialog.locstring.json';
import { setFeedbackCategories } from '../mutators/setFeedbackCategories';
import { setFeedbackSubcategories } from '../mutators/setFeedbackSubcategories';
import { setInlineFeedbackResponseCategories } from '../mutators/setInlineFeedbackResponseCategories';
import { inlineFeedbackDialogStore } from '../store/store';
import { sliceCategories, sliceCategory } from '../utils/validateInlineFeedbackDialogProps';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { ComboBox, IComboBoxOption } from 'office-ui-fabric-react/lib/ComboBox';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import loc from 'owa-localize';
import * as React from 'react';

let styles = require('./InlineFeedbackDialog.scss');

export interface FeedbackCheckBoxProps {
    subCategories?: FeedbackCategory[];
    category?: FeedbackCategory;
}

const FeedbackCheckBox = (props: FeedbackCheckBoxProps) => {
    const { category, subCategories } = props;
    let slicedCategory = sliceCategory(category.uiString);
    let selectedSubCategories: FeedbackCategory[];
    let subCategoriesAsComboBoxOptions: IComboBoxOption[];

    if (!!subCategories) {
        // when there are inline suggestions, the callback for when the checkbox is selected is different.
        // instead of enabling the submit button, we should display a ComboBox

        subCategoriesAsComboBoxOptions = sliceCategories(subCategories).map(subCategory => {
            return { key: subCategory.logString, text: subCategory.uiString };
        });

        selectedSubCategories = inlineFeedbackDialogStore().subCategories.get(category.uiString);
    }

    const onCategoryCheckboxChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        const { subCategories, category } = props;

        !!subCategories
            ? setFeedbackCategories(category.uiString, checked)
            : setInlineFeedbackResponseCategories(ev.currentTarget.getAttribute('name'), checked);
    };

    const onOptionSelected = (event: any, option: IComboBoxOption) => {
        const { category } = props;
        if (option) {
            setFeedbackSubcategories(option.key.toString(), option.text, option.selected, category);
        }
    };

    const getFeedbackCheckBox = () => {
        return (
            <>
                <Checkbox
                    className={category.categoryClassName || styles.checkbox}
                    key={category.logString || slicedCategory}
                    label={slicedCategory}
                    name={category.logString || slicedCategory}
                    defaultChecked={false}
                    onChange={onCategoryCheckboxChange}
                />
                {selectedSubCategories && (
                    <ComboBox
                        multiSelect={true}
                        options={subCategoriesAsComboBoxOptions}
                        selectedKey={getSelectedKeys(selectedSubCategories)}
                        onChange={onOptionSelected}
                        className={styles.feedbackComboBox}
                        placeholder={loc(feedbackDialogDropDownPlaceHolder)}
                        useComboBoxAsMenuWidth={true}
                    />
                )}
            </>
        );
    };

    const getSelectedKeys = (subCategories: FeedbackCategory[]) => {
        return subCategories ? subCategories.map(subCategory => subCategory.logString) : null;
    };

    if (slicedCategory !== category.uiString) {
        return <TooltipHost content={category.uiString}>{getFeedbackCheckBox()}</TooltipHost>;
    } else {
        return <>{getFeedbackCheckBox()}</>;
    }
};

export default FeedbackCheckBox;
